export default () => ({
  inventoryList: [],
  loading: false,
  currentPage: 1,
  totalPages: 1,
  loadingPage: false,
  tags: [],
  filters: {
    campaignId: null,
    productId: null,
    search: null,
    filter_by: null,
    tag_ids: null,
    sort: '-date_added'
  },
})
